/** Wraps text to the same measured width used by the exported image. */
export function wrapShareText(context, value, maxWidth, maxLines = Infinity) {
  const lines = [];
  let line = '';
  for (const word of String(value || '').split(/\s+/).filter(Boolean)) {
    const candidate = line ? `${line} ${word}` : word;
    if (context.measureText(candidate).width <= maxWidth) {
      line = candidate;
      continue;
    }
    if (line) { lines.push(line); line = ''; }
    let fragment = '';
    for (const character of word) {
      if (fragment && context.measureText(fragment + character).width > maxWidth) {
        lines.push(fragment);
        fragment = character;
      } else fragment += character;
    }
    line = fragment;
  }
  if (line) lines.push(line);
  if (lines.length <= maxLines) return lines;
  const visible = lines.slice(0, maxLines);
  let finalLine = visible[maxLines - 1];
  while (finalLine && context.measureText(`${finalLine}…`).width > maxWidth) finalLine = finalLine.slice(0, -1);
  visible[maxLines - 1] = `${finalLine}…`;
  return visible;
}

/** Fits a share title before allowing truncation at the smallest legible size. */
export function fitShareTitle(context, title, maxWidth, preferredSize, minimumSize, maxLines) {
  for (let size = preferredSize; size >= minimumSize; size -= 2) {
    context.font = `850 ${size}px system-ui, sans-serif`;
    const lines = wrapShareText(context, title, maxWidth);
    if (lines.length <= maxLines) return { lines, size, truncated: false };
  }
  context.font = `850 ${minimumSize}px system-ui, sans-serif`;
  return { lines: wrapShareText(context, title, maxWidth, maxLines), size: minimumSize, truncated: true };
}

/** Gives title, metrics, and review their space before sizing the Post media. */
export function postMediaHeight({ height, padding, hasMedia, titleLines, titleLineHeight, subtitleLines, metricCount, reviewLines }) {
  const base = Math.round(height * (hasMedia ? 0.43 : 0.23));
  const minimum = hasMedia ? 245 : 190;
  const metricRows = Math.ceil(Math.min(metricCount, 4) / 2);
  const contentHeight = 42 + 54 + titleLines * titleLineHeight + subtitleLines * 39
    + (metricRows ? 20 + metricRows * 116 + 12 : 0) + reviewLines * 42;
  const footerSafeTop = height - 160;
  return Math.max(minimum, Math.min(base, footerSafeTop - padding - 42 - contentHeight));
}
